import React, { createContext, useState, useContext, useEffect } from 'react';

const AccessibilityContext = createContext();

export const useAccessibility = () => {
  const context = useContext(AccessibilityContext);
  if (!context) {
    throw new Error('useAccessibility debe ser usado dentro de AccessibilityProvider');
  }
  return context;
};

export const AccessibilityProvider = ({ children }) => {
  const [textSize, setTextSize] = useState(1);
  const [grayscale, setGrayscale] = useState(false);
  const [highContrast, setHighContrast] = useState(false);
  const [readableFont, setReadableFont] = useState(false);
  const [underlineLinks, setUnderlineLinks] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;
    // Aplicar tamaño en :root para que todos los rem escalen (arregla que el botón +/- no se notara)
    if (textSize !== 1) {
      root.style.setProperty('font-size', `${textSize * 100}%`);
      root.style.setProperty('--accessibility-text-scale', String(textSize));
    } else {
      root.style.removeProperty('font-size');
      root.style.removeProperty('--accessibility-text-scale');
    }
    body.style.filter = grayscale ? 'grayscale(100%)' : 'none';
    body.classList.toggle('high-contrast', highContrast);
    body.classList.toggle('readable-font', readableFont);
    body.classList.toggle('underline-links', underlineLinks);
  }, [textSize, grayscale, highContrast, readableFont, underlineLinks]);

  const resetAccessibility = () => {
    setTextSize(1);
    setGrayscale(false);
    setHighContrast(false);
    setReadableFont(false);
    setUnderlineLinks(false);
  };

  return (
    <AccessibilityContext.Provider
      value={{
        textSize,
        setTextSize,
        grayscale,
        setGrayscale,
        highContrast,
        setHighContrast,
        readableFont,
        setReadableFont,
        underlineLinks,
        setUnderlineLinks,
        isOpen,
        setIsOpen,
        resetAccessibility
      }}
    >
      {children}
    </AccessibilityContext.Provider>
  );
};


















